import React, { useContext } from 'react';
import AddImage from '../../../../../Assets/Add image.svg';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { loadImage } from '../../../../../lib/utils/utils';
import { v4 as uuidv4 } from 'uuid';

function ImageInput() {
    const {
        aboutThree,
        setAboutThree,
    } = useContext(StorefrontContext);

    async function handleImageChange(e) {
        const file = e.target.files[0];

        if(file) {
            const img = await loadImage(file);

            const selectedImage = {
                id: uuidv4(),
                url: img.src,
                file: file,
            }

            setAboutThree({ ...aboutThree, image: selectedImage });
        }

        e.target.value = null;
    }

    return (
        <div className='flex flex-col gap-2'>
            <p className='font-medium text-[14px] leading-6 text-[#121212]'>Image</p>

            <div className="flex items-center gap-3">
                {
                    aboutThree.image.url ? 
                    <div className="size-[100px] rounded-lg overflow-hidden">
                        <img className='size-full object-cover' src={aboutThree.image.url} alt="" />
                    </div> : 
                    <label htmlFor='image' className="size-[100px] rounded-lg overflow-hidden bg-[#666666] flex items-center justify-center cursor-pointer">
                        <img className='size-1/2' src={AddImage} alt="" />
                    </label>
                }

                <input 
                    id='image' 
                    name='image' 
                    className='hidden' 
                    type="file" 
                    accept='image/*' 
                    onChange={handleImageChange} 
                />

                <label htmlFor='image' className='outline-none px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[12px] leading-6 text-buttonText cursor-pointer'>Change Image</label>
            </div>
        </div>
    );
}

export default ImageInput;
